import GalleryImageDescriptionContainer from "../../Componant/Gallery/GalleryGridWithDescription/index.";

const GalleryGridWithDescription = () => {
  return (
    <div className="page-body">
      <GalleryImageDescriptionContainer />
    </div>
  );
};

export default GalleryGridWithDescription;
